<div class="cleanup-administration">

  <div class="widget-menu-layer-1 no-field-space top-toolbar">

    <form [formGroup]="carrierQueryFormGroup">
      <sc-flex startAligned>
        <sc-flex-fitting-content>
          <sc-text-field labelDictionaryKey="tmc-yard.ui.admin.cleanup-administration.carrier-query"
          formControlName="query" [minlength]="1" required="true"></sc-text-field>
        </sc-flex-fitting-content>
        <sc-content-spacer></sc-content-spacer>

        <sc-button dictionaryKey="tmc-yard.ui.admin.cleanup-administration.action.find-carrier" (click)="findCarriersByQuery()" [disabled]="loading || !carrierQueryValid">

        </sc-button>
      </sc-flex>
    </form>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.cleanup-administration.help.find-carrier"></sc-dictionary-label>

  </div>

  @if (responseMessages != null && responseMessages.length > 0) {
    <div class="response-container">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
  }

  <div class="table-container">

    <table mat-table [dataSource]="dataSource" class="table">

      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell class="" *matCellDef="let carrier">
          <mat-checkbox [checked]="carrier.selected" (change)="carrierSelectionChanged(carrier)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.carrier"></sc-dictionary-label>
        </th>
        <td mat-cell class="" *matCellDef="let carrier">
          {{carrier.carrier}}
        </td>
      </ng-container>

      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.cleanup-administration.carrier.count"></sc-dictionary-label>
        </th>
        <td mat-cell class="" *matCellDef="let carrier">
          {{carrier.count}}
        </td>
      </ng-container>

      <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
      <ng-container matColumnDef="noRecord">
        <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
          <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let carrier; columns: columnsToDisplay">
      </tr>

      <tr [class.hide]="this.dataSource.filteredData.length !== 0" mat-footer-row *matFooterRowDef="['noRecord']">
      </tr>
    </table>
  </div>

  <form [formGroup]="carrierReplacementFormGroup">
    <sc-flex startAligned>
      <sc-flex-fitting-content>
        <sc-text-field labelDictionaryKey="tmc-yard.ui.admin.cleanup-administration.update-carrier-with"
        formControlName="replacement" [minlength]="1" required="true"></sc-text-field>
      </sc-flex-fitting-content>
      <sc-content-spacer></sc-content-spacer>

      <sc-button dictionaryKey="tmc-yard.ui.admin.cleanup-administration.action.update-carrier" (click)="findAndReplace()" [disabled]="loading || !replaceButtonEnabled">

      </sc-button>
    </sc-flex>
  </form>

</div>
